import type { TIconProps } from "./types";

export const Google = (props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.52 12.2727C23.52 11.4218 23.4436 10.6036 23.3018 9.81812H12V14.4599H18.4582C18.18 15.9599 17.3345 17.2308 16.0636 18.0817V21.0927H19.9418C22.2109 19.0036 23.52 15.9272 23.52 12.2727Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23.9998C15.24 23.9998 17.9564 22.9252 19.9418 21.0925L16.0636 18.0816C14.9891 18.8016 13.6145 19.2271 12 19.2271C8.87455 19.2271 6.22909 17.1161 5.28546 14.2798H1.27637V17.3889C3.25091 21.3107 7.30909 23.9998 12 23.9998Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.28545 14.2802C5.04545 13.5602 4.90909 12.7911 4.90909 12.0002C4.90909 11.2093 5.04545 10.4402 5.28545 9.72017V6.61108H1.27636C0.463636 8.23108 0 10.0638 0 12.0002C0 13.9365 0.463636 15.7693 1.27636 17.3893L5.28545 14.2802Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.77273C13.7618 4.77273 15.3436 5.37818 16.5873 6.56727L20.0291 3.12545C17.9509 1.18909 15.2346 0 12 0C7.3091 0 3.25091 2.68909 1.27637 6.61091L5.28546 9.72C6.22909 6.88364 8.87455 4.77273 12 4.77273Z"
        fill="#EA4335"
      />
    </svg>
  );
};
